module.exports = __webpack_public_path__ + "img/how_it_works_1.3918ad17.png";